export default __webpack_public_path__ + "static/media/Zone-5-Master-Plan-Type-H.bc547efe.png";